// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QQDv","content":"styles_content__1HGo5","tableWrap":"styles_tableWrap__eBKmD"};